import { render, staticRenderFns } from "./ConsolidationUnionCreateLabel.vue?vue&type=template&id=455ae472&scoped=true"
import script from "./ConsolidationUnionCreateLabel.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionCreateLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ae472",
  null
  
)

export default component.exports